import { Translation, QRType } from '../types';

export const ms: Translation = {
  nav: {
    generator: 'Penjana',
    scanner: 'Pengimbas',
    mobile: 'Cuba di Mudah Alih',
    blog: 'Blog',
    langSelect: 'Pilih Bahasa',
  },
  pageTitles: {
    generator: 'Penjana Kod QR Percuma Dalam Talian',
    scanner: 'Pengimbas Kod QR Dalam Talian',
    textToQr: 'Penukar Teks ke Kod QR',
    linkToQr: 'Penjana Kod QR untuk Pautan',
  },
  pageMeta: {
    generator: {
      title:
        'Penjana Kod QR Percuma — Cipta Kod QR Dalam Talian (Tanpa Daftar, Tanpa Watermark, PNG/SVG/PDF) | YesQRCode',
      description:
        'Cipta kod QR dalam talian secara percuma dengan YesQRCode. Jana URL, teks, Wi‑Fi, vCard dan banyak lagi. Muat turun PNG, SVG atau PDF berkualiti tinggi. Tiada daftar, tiada log masuk, tiada watermark — pantas, selamat dan percuma selama‑lamanya.',
      keywords: [
        'penjana kod qr',
        'penjana kod qr percuma',
        'cipta kod qr dalam talian',
        'pembuat kod qr',
        'kod qr png',
        'kod qr svg',
        'kod qr pdf',
        'penjana kod qr wifi',
        'penjana kod qr vcard',
        'penjana qr tanpa daftar',
      ],
    },
    scanner: {
      title:
        'Pengimbas Kod QR Dalam Talian — Imbas dari Imej atau Kamera (Selamat, Tanpa Daftar) | YesQRCode',
      description:
        'Imbas kod QR dan kod bar secara percuma dalam talian. Muat naik imej atau gunakan kamera. Semua pemprosesan berlaku secara tempatan tanpa muat naik. Selamat, pantas, tanpa daftar, tanpa log masuk, dan percuma sepenuhnya.',
      keywords: [
        'pengimbas kod qr',
        'imbas kod qr dalam talian',
        'pembaca qr dalam talian',
        'imbas qr dari imej',
        'imbas kod bar dalam talian',
        'pengimbas qr selamat',
        'pengimbas qr tanpa muat naik',
        'pengimbas qr percuma',
        'pengimbas qr pelayar',
        'pengimbas qr tanpa daftar',
      ],
    },
    textToQr: {
      title: 'Teks ke QR | Tukar Nota kepada Kod QR',
      description:
        'Tukar petikan teks, nota atau mesej kepada kod QR yang boleh dikongsi. Terapkan penjenamaan dan eksport PNG, SVG atau PDF dengan segera tanpa pendaftaran.',
      keywords: ['teks ke qr', 'penjana qr teks', 'nota kod qr', 'mesej qr', 'penukar qr dalam talian', 'qr teks percuma'],
    },
    linkToQr: {
      title: 'Pautan ke QR | Tukar URL kepada Kod QR',
      description:
        'Tampal mana-mana URL laman web atau kempen dan jana kod QR berjenama serta-merta untuk cetakan atau digital. Menyokong warna tersuai, logo dan muat turun resolusi tinggi.',
      keywords: ['pautan ke qr', 'penjana qr url', 'qr laman web', 'qr untuk pautan', 'utm kod qr', 'muat turun qr pdf'],
    },
  },
  hero: {
    title: 'Cipta kod QR peribadi, sedia untuk jenama — percuma selama‑lamanya.',
    subtitle: 'Alat QR yang pantas, peribadi dan fleksibel untuk sebarang aliran kerja.',
    desc: 'Jana dan imbas kod QR berkualiti tinggi tanpa akaun, watermark, atau muat naik data.',
    ctaPrimary: 'Jana Kod QR',
    ctaSecondary: 'Cuba di Mudah Alih',
  },
  info: {
    helpTitle: 'Pusat Bantuan',
    helpSubtitle: 'Soalan Lazim & Sokongan',
    contactTitle: 'Hubungi Kami',
    contactSubtitle: 'Kami ingin mendengar daripada anda.',
    privacyTitle: 'Dasar Privasi',
    termsTitle: 'Terma Perkhidmatan',
  },
  contactForm: {
    name: 'Nama',
    email: 'E-mel',
    message: 'Mesej',
    send: 'Hantar Mesej',
    orEmail: 'atau e-mel terus kepada kami di',
    sending: 'Menghantar...',
    successTitle: 'Mesej Dihantar!',
    successMessage: 'Terima kasih kerana menghubungi kami. Kami akan membalas tidak lama lagi.',
    sendAnother: 'Hantar mesej lain',
    errorMessage: 'Kami tidak dapat menghantar mesej anda sekarang. Sila e-mel support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Cipta kod QR peribadi, sedia untuk jenama — percuma selama‑lamanya.',
      subtitle: 'Alat QR yang pantas, peribadi dan fleksibel untuk sebarang aliran kerja.',
      items: [
        {
          title: 'Utamakan privasi, penjanaan pada peranti',
          desc: 'Kod QR dijana secara tempatan — tiada muat naik, tiada penjejakan, tiada data disimpan.',
        },
        {
          title: 'Ciri lengkap untuk semua kegunaan',
          desc: 'URL, Wi‑Fi, vCard, kod bar, logo, gradien, bingkai — semuanya tersedia.',
        },
        {
          title: 'Mesra mudah alih dan mudah untuk semua',
          desc: 'Dioptimumkan untuk telefon dan interaksi sentuh bagi penciptaan dan imbasan yang lancar.',
        },
        {
          title: 'Percuma selama‑lamanya, selamat untuk kegunaan komersial',
          desc: 'Tiada akaun, tiada watermark, tiada had imbasan — boleh dipercayai untuk pasukan dan perniagaan.',
        },
      ],
    },
    featureSuite: {
      title: 'Suite kod QR lengkap yang mengutamakan privasi',
      subtitle: 'Segala yang anda perlukan untuk menghasilkan kod QR yang kemas, berjenama dan berkualiti tinggi — semuanya di satu tempat.',
      categories: [
        {
          title: 'Semua jenis kod QR yang anda perlukan',
          body: 'URL, Teks, Wi‑Fi, E-mel, Telefon, SMS, vCard, pautan sosial, YouTube, kod bar. Kod statik yang tidak luput.',
          items: [],
        },
        {
          title: 'Penjenamaan & Reka Bentuk',
          body: 'Kod selamat untuk logo, gradien, bingkai, bentuk, sudut, dan susun atur dioptimumkan untuk imbasan.',
          items: [],
        },
        {
          title: 'Output & Kualiti',
          body: 'Eksport PNG, SVG dan PDF berkualiti tinggi, dengan pratetap untuk cetakan dan digital.',
          items: [],
        },
        {
          title: 'Global & Kebolehgunaan',
          body: 'UI pelbagai bahasa, reka bentuk mobile-first, dan aliran kerja mesra luar talian.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Dipercayai oleh pencipta, pasukan dan jenama',
      subtitle:
        'YesQRCode direka agar ringan, konsisten dan selamat untuk kempen jangka panjang — tanpa akaun, tanpa vendor lock‑in, dan tanpa had tersembunyi.',
      items: ['Tiada onboarding', 'Kod statik yang boleh dijangka', 'Selamat untuk perusahaan: tiada pemprosesan awan', 'Penjenamaan konsisten di semua aset'],
    },
    sectionContent: 'Kandungan',
    sectionColors: 'Warna',
    sectionLogo: 'Logo',
    sectionFrame: 'Bingkai',
    sectionDesign: 'Reka Bentuk',
    sectionCorrection: 'Pembetulan Ralat',
    labelUrl: 'URL Laman Web',
    labelText: 'Teks Biasa',
    labelSsid: 'Nama Rangkaian (SSID)',
    labelPassword: 'Kata Laluan',
    labelEncryption: 'Penyulitan',
    labelFgColor: 'Bahagian Hadapan',
    labelBgColor: 'Latar Belakang',
    labelFrameText: 'Frasa Bingkai',
    labelFrameColor: 'Warna Bingkai',
    placeholder: 'Masukkan kandungan anda di sini...',
    placeholders: {
      url: 'https://example.com',
      text: 'Masukkan teks di sini',
      email: 'anda@email.com',
      subject: 'Subjek',
      message: 'Mesej anda...',
      phone: '+60 12-345 6789',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'Muat Turun PNG',
    downloadSvg: 'Muat Turun SVG',
    generateButton: 'Jana Kod QR',
    copy: 'Salin SVG',
    uploadLogo: 'Muat Naik Imej',
    preview: 'Pratonton',
    lowQuality: 'Kualiti Rendah',
    highQuality: 'Kualiti Tinggi',
    foreverFree: 'Percuma Selamanya • Tiada Daftar • Kegunaan Komersial',
    barcodeWarning: 'Pilihan reka bentuk lanjutan seperti Bingkai dan Logo tidak tersedia untuk Kod Bar.',
    barcodeColors: 'Anda masih boleh menyesuaikan Warna di bawah.',
    frameStyles: {
      none: 'Tiada',
      simple: 'Ringkas',
      balloon: 'Gelembung',
      box: 'Kotak',
      badge: 'Lencana',
      polaroid: 'Polaroid',
      phone: 'Telefon',
      header: 'Header',
      corner: 'Sudut',
    },
    vCard: {
      firstName: 'Nama Pertama',
      lastName: 'Nama Akhir',
      mobile: 'Mudah Alih',
      phone: 'Telefon',
      fax: 'Faks',
      email: 'E-mel',
      company: 'Syarikat',
      job: 'Jawatan',
      street: 'Jalan',
      city: 'Bandar',
      zip: 'Poskod',
      state: 'Negeri',
      country: 'Negara',
      website: 'Laman Web',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Teks',
      [QRType.EMAIL]: 'E-mel',
      [QRType.PHONE]: 'Telefon',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Kod Bar',
    },
    guide: {
      title: 'Bagaimana untuk mencipta Kod QR Tersuai?',
      steps: [],
    },
    gettingStarted: {
      title: 'Cara Menggunakan',
      steps: [
        {
          title: 'Tetapkan Kandungan QR',
          text: 'Pilih jenis kandungan di bahagian atas untuk kod QR anda (URL, Teks, E-mel...). Selepas memilih jenis, anda akan melihat semua pilihan yang tersedia. Masukkan semua medan yang perlu muncul apabila kod QR diimbas. Pastikan semuanya betul kerana anda tidak boleh mengubah kandungan selepas kod QR dicetak.',
        },
        {
          title: 'Sesuaikan Reka Bentuk',
          text: 'Mahukan kod QR yang unik? Tetapkan warna tersuai dan tukar bentuk standard kod QR anda. Elemen sudut dan badan boleh disesuaikan secara berasingan. Tambah logo pada kod QR anda, pilih daripada galeri atau muat naik imej logo anda sendiri.',
        },
        {
          title: 'Jana Kod QR',
          text: 'Tetapkan resolusi piksel kod QR anda dengan peluncur. Klik butang “Muat Turun” untuk menyimpan kod QR anda. Pastikan kod QR berfungsi dengan mengimbas pratonton menggunakan pengimbas anda. Gunakan resolusi tinggi jika anda mahu PNG berkualiti cetakan.',
        },
        {
          title: 'Muat Turun Imej',
          text: 'Kini anda boleh memuat turun fail imej kod QR anda sebagai .png, .svg atau .pdf. Jika anda mahukan format vektor dengan reka bentuk lengkap, pilih .svg. SVG berfungsi dalam perisian seperti Adobe Illustrator atau Inkscape. Logo dan tetapan reka bentuk kini hanya berfungsi untuk fail .png dan .svg.',
        },
      ],
    },
    about: {
      title: 'Suite Kod QR Percuma yang Mengutamakan Privasi',
      subtitle:
        'Jana dan imbas kod QR berkualiti tinggi tanpa akaun, watermark, atau muat naik data. Dioptimumkan untuk cetakan, penjenamaan dan kegunaan komersial.',
      features: [
        'Semua jenis popular: URL, Teks, Wi‑Fi, vCard, SMS dan kod bar',
        'Selamat untuk logo dengan sehingga 30% pembetulan ralat',
        'Bentuk, gradien, warna dan bingkai tersuai',
        'Kod QR statik yang tidak luput',
        'UI pelbagai bahasa untuk pasukan global',
      ],
      content: [
        {
          title: 'Kod QR selamat untuk logo',
          body: 'Tambah logo tanpa bimbang kegagalan imbasan. Dengan sehingga 30% pembetulan ralat, lapisan berjenama kekal boleh dibaca untuk pembungkusan, menu dan papan tanda.',
        },
        {
          title: 'Bentuk dan bingkai tersuai',
          body: 'Tukar bentuk sudut, gunakan gradien, dan pilih bingkai yang sepadan dengan kempen anda. Kawalan berfokus reka bentuk memastikan kod kekal boleh diimbas sambil nampak berjenama.',
        },
        {
          title: 'Pelbagai jenis kandungan',
          body: 'Jana kod URL, teks, Wi‑Fi, vCard, SMS dan kod bar di satu tempat, dengan pratetap yang memudahkan persediaan bagi setiap format.',
        },
        {
          title: 'Kod statik yang tahan lama',
          body: 'Cipta kod QR statik yang tidak luput atau mengehadkan imbasan — sesuai untuk kempen jangka panjang dan aset bercetak.',
        },
      ],
    },
    faq: {
      title: 'Soalan Lazim',
      items: [
        {
          q: 'Apa itu kod QR?',
          a: 'Kod QR bermaksud Quick Response Code dan merupakan sejenis kod bar yang dicipta oleh Denso Wave pada tahun 1994.',
        },
        {
          q: 'Bolehkah saya gunakan kod QR yang dijana untuk tujuan komersial?',
          a: 'Ya, semua kod QR yang anda cipta dengan penjana ini adalah percuma dan boleh digunakan untuk apa sahaja.',
        },
        {
          q: 'Adakah kod QR yang dijana akan luput?',
          a: 'Tidak luput dan akan berfungsi selama‑lamanya! Kod QR yang dicipta dengan YesQRCode adalah statik dan tidak berhenti berfungsi selepas suatu tempoh. Anda cuma tidak boleh mengubah kandungannya selepas dijana.',
        },
        {
          q: 'Adakah terdapat had imbasan untuk kod QR?',
          a: 'Tiada had dan kod QR yang dijana akan berfungsi selamanya. Imbas sebanyak mana yang anda mahu!',
        },
        {
          q: 'Adakah YesQRCode menyimpan data saya?',
          a: 'Kami tidak menyimpan atau menggunakan semula data anda dalam apa jua bentuk. Kami menyimpan cache fail imej kod QR anda selama 24 jam di pelayan kami untuk mengoptimumkan prestasi.',
        },
        {
          q: 'Mengapa vCard QR saya tidak memaparkan medan yang betul?',
          a: 'Tidak semua pengimbas kod QR mematuhi standard vCard rasmi, menyebabkan medan kenalan bercampur. Sila cuba aplikasi pengimbas lain untuk hasil yang lebih baik.',
        },
        {
          q: 'Kod QR saya tidak berfungsi, apa yang boleh saya buat?',
          a: 'Terdapat banyak sebab kod QR tidak berfungsi. Semak data yang dimasukkan — tersilap taip URL boleh memecahkan kod QR. Sesetengah kod (seperti vCard) mengandungi banyak data; kurangkan data jika boleh. Cuba buang logo dan lihat sama ada membantu. Pastikan juga kontras mencukupi antara latar dan hadapan; bahagian hadapan mestilah lebih gelap daripada latar.',
        },
        {
          q: 'Adakah YesQRCode berfungsi di semua pelayar?',
          a: 'YesQRCode memerlukan pelayar moden yang menyokong HTML5 dan secara rasmi menyokong Chrome, Firefox, Safari, Edge dan Internet Explorer 11.',
        },
      ],
    },
  },
  scanner: {
    title: 'Imbas QR & Kod Bar',
    subtitle: 'Guna kamera, muat naik imej, atau tampal untuk menyahkod QR dan kod bar dengan pantas.',
    cameraPermission: 'Akses kamera ditolak. Sila benarkan kebenaran dalam tetapan pelayar anda.',
    result: 'Keputusan',
    copy: 'Salin',
    copied: 'Disalin',
    open: 'Buka Pautan',
    delete: 'Padam',
    scanAgain: 'Imbas Lagi',
    privacy: 'Pemprosesan berlaku secara tempatan dalam pelayar anda. Fail tidak meninggalkan peranti anda.',
    upload: 'Muat Naik Imej',
    paste: 'Tampal (Ctrl+V)',
    drop: 'Lepaskan imej di sini',
    retry: 'Cuba Lagi',
    errorAccessDenied: 'Akses Kamera Ditolak',
    errorCamera: 'Sila benarkan akses kamera dalam tetapan pelayar.',
    initializing: 'Memulakan Kamera...',
    cameraActive: 'Kamera Aktif',
    scannedItems: 'Item Diimbas',
    recentScans: 'Terkini (disimpan tempatan)',
    clickToUpload: 'Klik untuk Muat Naik',
    newBadge: 'BAHARU',
    tabCameraMobile: 'Kamera',
    tabCameraDesktop: 'Imbas melalui Kamera',
    emptyState: {
      title: 'Belum ada imbasan',
      desc: 'Muat naik imej atau gunakan tab kamera untuk bermula.',
    },
    highlights: {
      title: 'Imbasan pantas, peribadi',
      items: [
        { title: 'Nyahkod pada peranti', desc: 'Tiada muat naik secara lalai; selamat untuk URL/aset sensitif.' },
        { title: 'Pelbagai format', desc: 'QR serta UPC/EAN, Code 128, ITF, dan banyak lagi.' },
        { title: 'Tindakan pantas', desc: 'Lepas fail, tampal tangkapan skrin, atau tukar ke imbasan langsung segera.' },
        { title: 'Hebat di mudah alih', desc: 'UI dan aliran kamera dioptimumkan untuk telefon dan skrin kecil.' },
      ],
    },
    intro: {
      title: 'Pengimbas QR & Kod Bar Dalam Talian',
      body: 'Nyahkod Kod QR, UPC, EAN dan lain-lain terus dalam pelayar tanpa memasang aplikasi.',
    },
    howTo: {
      title: 'Cara mengimbas?',
      methods: [
        {
          title: 'Kaedah 1: Muat naik',
          steps: ['Klik Muat Naik Imej', 'Pilih QR/kod bar anda', 'Dapatkan keputusan segera'],
        },
        {
          title: 'Kaedah 2: Kamera',
          steps: ['Buka tab Kamera', 'Berikan kebenaran', 'Halakan ke QR/kod bar'],
        },
      ],
    },
    features: {
      title: 'Mengapa guna pengimbas ini?',
      items: [
        { title: 'Sejarah tempatan', desc: 'Imbasan terkini disimpan pada peranti anda sahaja, mudah disalin atau dibuka semula.' },
        { title: 'Nyahkod imej luar talian', desc: 'Muat naik atau tampal imej walaupun sambungan terputus.' },
        { title: 'Tindakan cepat', desc: 'Salin, buka, atau padam keputusan dengan kawalan yang ringkas.' },
      ],
    },
    useCases: {
      title: 'Kegunaan Popular',
      items: [
        { title: 'Runcit & Membeli-belah', desc: 'Semak URL produk, kupon, atau arahan.' },
        { title: 'Pasukan Inventori', desc: 'Sahkan kod bar dan urus kemas kini stok.' },
        { title: 'Pengguna Harian', desc: 'Buka menu, pautan Wi‑Fi, atau kad kenalan dengan cepat.' },
      ],
    },
    faq: {
      title: 'FAQ Pengimbas',
      items: [
        { q: 'Boleh saya imbas kod bar?', a: 'Ya, pengimbas menyokong kod QR serta Code 128, UPC, EAN, ITF, dan banyak lagi.' },
        { q: 'Adakah anda menyimpan imbasan saya?', a: 'Tiada imbasan meninggalkan pelayar; semuanya kekal pada peranti anda.' },
        { q: 'Boleh saya tampal tangkapan skrin?', a: 'Ya, tekan Ctrl+V (Cmd+V) untuk tampal dari papan klip.' },
        { q: 'Adakah ia berfungsi luar talian?', a: 'Muat naik imej berfungsi luar talian; imbasan kamera memerlukan kebenaran dan pelayar yang disokong.' },
      ],
    },
  },
  blog: {
    title: 'Wawasan & Panduan',
    subtitle: 'Amalan terbaik, idea pemasaran, dan kemas kini produk untuk pengalaman QR.',
    readMore: 'Baca artikel',
    back: 'Kembali ke blog',
    notFound: 'Artikel tidak ditemui',
  },
  common: {
    footer: 'Suite penciptaan QR yang berkuasa untuk pemasar, pereka, dan pasukan.',
    privacy: 'Privasi',
    terms: 'Terma',
    contact: 'Hubungi',
    scanToOpen: 'Imbas untuk buka di mudah alih',
    help: 'Bantuan',
    free: 'Percuma',
    product: 'Produk',
    resources: 'Sumber',
    company: 'Syarikat',
    api: 'API (Akan Datang)',
    systemStatus: 'Sistem Beroperasi',
    footerDesc:
      'Penjana dan pengimbas kod QR yang paling maju. Pantas, mengutamakan privasi, dan percuma selama‑lamanya untuk kegunaan peribadi dan komersial.',
  },
};

